import React from "react";

function BootstrapHeading({ title, subheading }) {
  return (
    <div style={{ marginTop: "2em" }}>
      <h5>{title}</h5>
      <p className="lead">{subheading}</p>
    </div>
  );
}

export default BootstrapHeading;
